import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import BirthChartExperience from "../components/tools/BirthChartExperience";
import '../assets/ascendant-display.sass';

const BirthChartPage = () => (
      <DynamicLayout>
    <BirthChartExperience />
  </DynamicLayout>
);

export default BirthChartPage;
